var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.compartidoPor != ""
    ? _c(
        "div",
        {
          staticClass: "text-xs-center d-flex align-center",
          staticStyle: { "padding-left": "1px" }
        },
        [
          _c(
            "v-avatar",
            {
              attrs: { title: "Vehículo compartido por: " + _vm.compartidoPor }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: { "padding-top": "8px", "padding-left": "1px" },
                  attrs: { color: "grey", dark: "" }
                },
                [_vm._v("directions_car")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }